import React from 'react';
import Classes from './styles/style.module.css';

const CustomSwitch = ({ value, OnChange }) => {
    const handleChange = (e) => {
        OnChange(e.target.checked);
    }
    return (
        <div>
            <label className={Classes.switch}>
                <input checked={value} type="checkbox" onChange={handleChange} />
                <span className={`${Classes.slider}  ${Classes.round}`} ></span>
            </label>
        </div>
    );
}

export default CustomSwitch;
